import { createFileRoute, Outlet } from "@tanstack/react-router"

/** Run log: list (`/insights/runs`) and full-page detail (`/insights/runs/$runId`). */
export const Route = createFileRoute("/_app/insights/runs")({
  staticData: { titleKey: "nav.items.runs" },
  component: Outlet,
})
